export const enUSBills = {
  pageTitle: 'Recurring Bills',
  addBill: 'Add Bill',
  createFirstBill: 'Create First Bill',
  noBillsYet: 'No recurring bills yet...',
  monthlyTotal: 'Monthly Total',
  filterAll: 'All ({{count}})',
  filterActive: 'Active ({{count}})',
  filterInactive: 'Inactive ({{count}})',
  filterLabel: 'Filter bills',
  noMatchFilter: 'No bills match the current filter.',
  errorLoad: 'Error loading bills: {{error}}',
  modalEditTitle: 'Edit Bill',
  modalAddTitle: 'Add Bill',
  statusEnded: 'Ended',
  statusActive: 'Active',
  statusPaused: 'Paused',
  recurrenceMonthly: 'Monthly',
  recurrenceYearly: 'Yearly',
  nextDue: 'Next due: ',
  installmentsPaid: '{{paid}}/{{total}} installments paid',
  categoryLabel: 'Category: ',
  notesLabel: 'Notes',
  accountLabel: 'Account: ',
  edit: 'Edit',
  end: 'End',
  delete: 'Delete',
  deleteTitle: 'Delete Bill',
  deleteMessage: 'Are you sure you want to delete "{{description}}"? This action cannot be undone.',
  deleteConfirm: 'Delete',
  endTitle: 'End Bill',
  endMessage: 'Are you sure you want to end "{{description}}"? The bill will be marked as ended.',
  endConfirm: 'End Bill',
  perMonth: '/month',
  formDescriptionLabel: 'Description *',
  formDescriptionPlaceholder: 'e.g., Netflix subscription',
  formAmountLabel: 'Amount *',
  formRecurrenceLabel: 'Recurrence *',
  formStartDateLabel: 'Start Date *',
  formEndDateLabel: 'End Date (optional)',
  formInstallmentsLabel: 'Installments Total (optional)',
  formInstallmentsPlaceholder: 'e.g., 12',
  formCategoryLabel: 'Category (optional)',
  formNotesLabel: 'Notes (Optional)',
  formNotesPlaceholder: 'Add a note about this bill...',
  formAccountLabel: 'Paying Account (optional)',
  formRecurrenceMonthly: 'Monthly',
  formRecurrenceYearly: 'Yearly',
  formSelectCategory: '-- Select Category --',
  formSelectAccount: '-- Select Account --',
  formCancel: 'Cancel',
  formSaving: 'Saving...',
  formUpdate: 'Update Bill',
  formCreate: 'Create Bill',
  validationDescriptionRequired: 'Description is required',
  validationDescriptionTooLong: 'Description too long',
  validationAmountRequired: 'Amount is required',
  validationStartDateRequired: 'Start date is required',
  validationInstallmentsPositive: 'Installments must be positive',
  validationNotesTooLong: 'Notes must be at most 500 characters',
  validationEndDateOrInstallments: 'Cannot specify both end date and installments total',
  toastCreated: 'Bill created',
  toastUpdated: 'Bill updated',
  toastDeleted: 'Bill deleted',
  toastEnded: 'Bill ended',
  toastCreateError: 'Failed to create bill',
  toastUpdateError: 'Failed to update bill',
  toastDeleteError: 'Failed to delete bill',
  toastEndError: 'Failed to end bill',
  noBillsTitle: 'No recurring bills',
  noBillsMessage: 'Track your monthly subscriptions and recurring payments.',
  files: {
    title: 'Files',
    addFile: 'Add file',
    uploadSuccess: 'File uploaded',
    uploadError: 'File upload failed',
    deleteConfirm: 'Remove this file?',
    deleteSuccess: 'File removed',
    deleteError: 'File removal failed',
    tooLarge: 'File must be under 10 MB',
  },
} as const;
